import type { SVGProps } from 'react'
const SvgSyArrowRight3 = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				d="M3.75 10.998a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h8.95a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75z"
				opacity={0.4}
			/>
			<path
				fillRule="evenodd"
				d="M12.338 6.092a.75.75 0 0 0-.389.656V16.75a.75.75 0 0 0 1.15.635l7.938-5.002a.75.75 0 0 0 0-1.27l-7.937-5a.75.75 0 0 0-.762-.021m1.111 2.013 5.78 3.643-5.78 3.643z"
				clipRule="evenodd"
			/>
		</g>
	</svg>
)
export default SvgSyArrowRight3
